import React, { useEffect } from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { ShieldAlert, CheckCircle2 } from "lucide-react";

export default function AnalyticsExcludePage() {
  useEffect(() => {
    try {
      localStorage.setItem("exclude_mobile", "true");
    } catch (e) {
      console.error("Failed to write exclude_mobile to localStorage:", e);
    }
  }, []);

  return (
    <div className="min-h-screen bg-[var(--page-bg)] text-[var(--brand-ink)]" data-testid="page-analytics-exclude">
      <Header />
      
      <main className="mx-auto max-w-2xl px-5 py-16 sm:px-8 text-center flex flex-col items-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100 text-emerald-600 mb-6">
          <CheckCircle2 size={36} />
        </div>
        
        <div className="flex items-center gap-2 text-brand-accent justify-center">
          <ShieldAlert size={16} strokeWidth={2.5} />
          <span className="label-kicker">Device Excluded</span>
        </div>
        
        <h2 className="brand-headline mt-2 font-display text-3xl font-black tracking-tight text-[var(--brand-ink)] sm:text-4xl">
          Google Analytics Disabled
        </h2>
        
        <p className="mt-4 text-base leading-relaxed text-[var(--brand-body)] max-w-md">
          This browser/device has been successfully excluded from Google Analytics tracking. It will no longer load or send page views to your Measurement ID (G-BMC62C2R22) on subsequent visits.
        </p>

        <div className="mt-8 rounded-md border border-black/10 bg-white p-4 max-w-sm text-xs font-mono text-left text-[var(--brand-body)]">
          <span className="font-bold text-[var(--brand-ink)] block mb-1">Local Settings State:</span>
          exclude_mobile: "true"
        </div>
      </main>

      <Footer />
    </div>
  );
}
